import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../DeviationPage/redux/helpers';
import AddToCollectionPopup from '../../_partials/AddToCollectionPopup';
import AddToPrivateCollectionButton from './AddToPrivateCollectionButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
const offsetModifier = [
    0,
    20
];
const FavouriteButtonWithPopover = ({ deviation, actionBarType })=>{
    var _popover_params;
    const isMobile = useContext(MobileContext);
    const { popover, removePopover, togglePopover } = usePopover(actionBarType === 'primary' ? PopoverType.ADD_TO_PRIVATE_COLLECTION_PRIMARY : PopoverType.ADD_TO_PRIVATE_COLLECTION_SECONDARY);
    const notificationQueue = isMobile ? 'default' : getDeviationNotificationQueue(deviation);
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: /*#__PURE__*/ React.createElement(AddToCollectionPopup, {
            isPrivateCollections: true,
            collectibleDeviation: deviation,
            notificationQueue: notificationQueue,
            ignorePreselectedCollections: (_popover_params = popover.params) === null || _popover_params === void 0 ? void 0 : _popover_params.ignorePreselectedCollections,
            onClose: removePopover
        }),
        placement: "bottom",
        isVisible: popover.isOpen,
        offsetModifier: offsetModifier,
        onClickOutside: isMobile ? undefined : removePopover
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButton, {
        deviation: deviation,
        onClick: togglePopover
    }));
};
FavouriteButtonWithPopover.displayName = 'FavouriteButtonWithPopover';
export default FavouriteButtonWithPopover;
